import { createAction, props } from '@ngrx/store';
import { CentralLobbyGridRequest } from '../../shared/models/central-lobby.request.model';
import { CentralStaffStatusViewGridRequest } from '../../shared/models/central-staff-status-grid.request.model';


export const loadCentralStaffStausViewGridData = createAction(
    '[Central View Assist GET] Load Central Staff View Data Grid',
    props<{ gridParams: CentralStaffStatusViewGridRequest }>()
);

export const loadCentralStaffStausViewGridDataSuccess = createAction(
    '[Lobby CheckIn API] Load staff status view grid data Success',
    props<{ gridData: any }>()
);

export const loadCentralStaffStausViewGridDataError = createAction(
    '[Lobby CheckIn API] Load staff status view grid data Error',
    props<{ error: string }>()
);

export const setAssistType = createAction(
    '[Central View Assist SET] Set LocationId',
    props<{ assistType: number }>()
);

export const loadAllLocations = createAction(
    '[Central View Locations GET] Load all locations',
    props<{ locationId: number[] }>()
);

export const loadAllLocationsSuccess = createAction(
    '[Central View Locations SET] Load all locations',
    props<{ locationIds: number[] }>()
);

export const setLocationIdsCheckedChange = createAction(
    '[Central View Locations SET] Set LocationId',
    props<{ locationId: number[], isChecked: boolean }>()
);


export const loadAllLocationsError = createAction(
    '[Central View Locations GET]  Load all location Failed',
    props<{ error: string }>()
);

export const searchTextChange = createAction(
    '[Central View Locations Search Text]  Search text Change',
    props<{ searchText: string }>()
);

export const loadCentralLobbyViewGridData = createAction(
    '[Central Lobby GET] Load Central Lobby Grid',
    props<{ gridParams: CentralLobbyGridRequest }>()
);

export const centralLobbySearchTextChange = createAction(
    '[Central Central Lobby Search Text]  Search text Change',
    props<{ searchText: string }>()
);

export const centralLobbyIsSpanishSpeakerChange = createAction(
    '[Central View Locations Search Text]  Search text Change',
    props<{ IsSpanishSpeaker: boolean }>()
);

